import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Form } from 'formik';

import {
  Label,
  Input,
  PhoneInput,
  Select,
  Button,
  CancelButton,
  FormBody,
  FormField,
  FormSpacer,
} from '../../elements';

const UserForm = ({ formSubmitting }) => {
  const navigate = useNavigate();

  return (
    <Form>
      <FormBody className="gray-input">
        <FormField>
          <Label>First Name</Label>
          <Input
            type="text"
            name="firstName"
          />
        </FormField>

        <FormField>
          <Label>Last Name</Label>
          <Input
            type="text"
            name="lastName"
          />
        </FormField>

        <FormField>
          <Label>Email Address</Label>
          <Input
            type="email"
            name="email"
          />
        </FormField>

        <FormField>
          <Label>Office Phone (optional)</Label>
          <PhoneInput name="officePhone" />
        </FormField>

        <FormField>
          <Label>Cell Phone (optional)</Label>
          <PhoneInput name="mobilePhone" />
        </FormField>

        <FormField>
          <Label>User Type</Label>
          <Select name="role">
            <option>Normal</option>
            <option>Admin</option>
          </Select>
          <p style={{marginTop: 12}}>
            Admin Users are allowed to view billing statements and User Link,
            Normal users are not.
          </p>
        </FormField>

        <FormSpacer />

        <FormField>
          <CancelButton
            type="button"
            onClick={() => navigate('/users')}
          >
            Cancel
          </CancelButton>
        </FormField>

        <FormField>
          <Button type="submit" disabled={formSubmitting}>Submit</Button>
        </FormField>
      </FormBody>
    </Form>
  );
};

export default UserForm;
